window.addEventListener("load", () => {
  initializePinboardReviewsSliders();
});

if (typeof acf !== "undefined") {
  acf.addAction(`render_block_preview`, function ($el, attributes) {
    if (attributes.name === "acf/pinboard-reviews") {
      initializePinboardReviewsSliders();
    }
  });
}

function initializePinboardReviewsSliders() {
  const allUSPSSliders = document.querySelectorAll(".ms_pinboard-reviews");
  for (const sliders of allUSPSSliders) {
    if (sliders.querySelector(".pinboard-reviews-slider")) {
      window.initializeSliders({
        id: sliders.id,
        main: sliders.querySelector(".pinboard-reviews-slider"),
        thumb: null,
        selector: "pinboard-reviews-slider",
      });
    }
  }
}
